import _ from 'underscore';
import React from 'react';
import { domainNameFromUrl } from 'javascripts/analytics/config/utilities';
import Permissions from 'javascripts/analytics/config/permissions';
import { NoDataTab } from 'javascripts/analytics/components/NoDataTab';
import { KeywordsHitsTable } from './keywords_hits_table';

export class KeywordsTabContainer extends React.Component {
  getStateFromStore = () => {
    return {
      models: Aedu.ReduxStore.getState().AnalyticsDashboard.Hits.models,
      siteSearches:
        Aedu.ReduxStore.getState().AnalyticsDashboard.SiteSearches.siteSearches,
      fetching:
        Aedu.ReduxStore.getState().AnalyticsDashboard.Hits.meta.fetching ||
        Aedu.ReduxStore.getState().AnalyticsDashboard.SiteSearches.meta
          .fetching,
    };
  };

  componentDidMount() {
    this.unsubscribe = Aedu.ReduxStore.subscribe(
      function () {
        this.setState(this.getStateFromStore());
      }.bind(this),
    );

    Aedu.ReduxStore.dispatch(
      Aedu.ActionCreators.AnalyticsDashboard.Hits.fetch(),
    );
    Aedu.ReduxStore.dispatch(
      Aedu.ActionCreators.AnalyticsDashboard.SiteSearches.fetch(),
    );
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  keywordHits = () => {
    return _.chain(this.state.models)
      .filter(function (hit) {
        return hit.referer && hit.referer.domain && hit.referer.query;
      })
      .map(
        function (hit) {
          return _.extend(
            {
              referingSearchEngine: this.referingSearchEngineForHit(hit),
            },
            hit,
          );
        }.bind(this),
      )
      .value();
  };

  internalKeywordHits = () => {
    if (this.state.siteSearches === undefined) {
      return [];
    }
    return this.state.siteSearches;
  };

  externalKeywordHits = () => {
    return this.keywordHits().filter(function (hit) {
      return hit.referer.domain !== window.$domain;
    });
  };

  referingSearchEngineForHit = (hit) => {
    if (!hit.referer) return '';
    if (hit.referer.name) return hit.referer.name;
    return domainNameFromUrl(hit.referer.url);
  };

  renderInternalKeywordHits = (internalKeywordHits) => {
    if (
      Aedu.ReduxStore.getState().AnalyticsDashboard.SiteSearches.meta.fetching
    ) {
      return this.renderSpinner();
    }
    return (
      <KeywordsHitsTable
        hits={internalKeywordHits}
        header="Academia.edu Searches"
        showKeywords={Permissions.inMode('premium')}
        info={
          'Academia suggested your papers in ' +
          $h.numberAndNoun(internalKeywordHits.length, 'search result') +
          '.'
        }
        isShareable={false}
        showSearchEngine={false}
        showPremiumIcon={true}
        isNewFeature={new Date() < new Date('March 31, 2017')}
      />
    );
  };

  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  renderExternalKeywordHits = (externalKeywordHits) => {
    if (Aedu.ReduxStore.getState().AnalyticsDashboard.Hits.meta.fetching) {
      return this.renderSpinner();
    }
    return (
      <KeywordsHitsTable
        hits={this.externalKeywordHits()}
        header="Search Engines"
        showKeywords={true}
        info="Clicks from search engines outside Academia"
        isShareable={true}
        showSearchEngine={true}
        showPremiumIcon={false}
        isNewFeature={false}
      />
    );
  };

  renderSpinner = () => {
    return (
      <div className="u-taCenter u-pv4x">
        <i className="fa fa-spin fa-spinner u-fs36"></i>
      </div>
    );
  };

  state = this.getStateFromStore();

  render() {
    const internalKeywordHits = this.internalKeywordHits();
    const externalKeywordHits = this.externalKeywordHits();
    const showInternalKeywordHits =
      (Permissions.inMode('upgradeable') || Permissions.inMode('premium')) &&
      internalKeywordHits.length > 0;
    if (internalKeywordHits.length > 0 || externalKeywordHits.length > 0) {
      return (
        <div>
          {showInternalKeywordHits &&
            this.renderInternalKeywordHits(internalKeywordHits)}
          {this.renderExternalKeywordHits(externalKeywordHits)}
        </div>
      );
    } else if (this.state.fetching) {
      return this.renderSpinner();
    } else {
      return (
        <NoDataTab
          title="You haven't received any search traffic with keywords
           in this time span."
          details="To get more search traffic, make sure you've uploaded
           and thoroughly tagged all your papers.<br>As readers find your work,
           this page will populate with data."
        />
      );
    }
  }
}
